const numberFormat = {
  currency: {
    style: 'currency',
    currency: 'CAD',
    notation: 'standard',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  },
  decimal: {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  },
  percent: {
    style: 'percent',
    useGrouping: false
  }
};

export default numberFormat;
